export function useDir() {
  const locale = useState<string>('page-locale', () => 'fa')
  return computed(() => (locale.value === 'fa' || locale.value === 'ar' ? 'rtl' : 'ltr'))
}
